@if(itemDetailsFormReady() && itemDetailsForm) {
    <form autocomplete="off" [formGroup]="itemDetailsForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <!-- Anagrafica -->
        <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.ITEM_DATA</mat-label>
        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-w-full">
                <mat-label translate>ITEMS.DETAILS.ORDER_NAME</mat-label>
                <input matInput formControlName="order_name" appTrimInput>
                <!-- <mat-icon 
                    matIconSuffix
                    #tooltip_orderName="matTooltip"
                    class="tw-cursor-pointer tw-text-gray-500"
                    [matTooltip]="'ITEMS.DETAILS.ORDER_NAME_INFO' | translate"
                    matTooltipPosition="above"
                    (click)="tooltip_orderName.toggle(); $event.stopPropagation()" 
                    aria-label="Informazioni aggiuntive">
                    info_outlined
                </mat-icon> -->
                <mat-hint [align]="'end'">{{itemDetailsSectionFormService.order_name?.value?.length || '0'}}
                    / {{itemDetailsSectionFormService.validators.orderNameMaxLength}}</mat-hint>
                @if(itemDetailsSectionFormService.order_name?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{itemDetailsSectionFormService.validators.orderNameMaxLength}})</mat-error>
                }
            </mat-form-field>
    
            <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center tw-h-full tw-min-h-[60px]">
                <mat-slide-toggle formControlName="is_frozen" aria-label="{{'ITEMS.DETAILS.IS_FROZEN' | translate}}">
                    {{'ITEMS.DETAILS.IS_FROZEN' | translate}}</mat-slide-toggle>
            </div>
    
            <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center tw-h-full tw-min-h-[60px]">
                <mat-slide-toggle formControlName="checkout_mark" aria-label="{{'ITEMS.DETAILS.CHECKOUT_MARK' | translate}}">
                    {{'ITEMS.DETAILS.CHECKOUT_MARK' | translate}}</mat-slide-toggle>
            </div>
    
            <mat-form-field class="tw-col-span-12 tw-w-full">
                <mat-label translate>ITEMS.DETAILS.DESCRIPTION</mat-label>
                <textarea matInput formControlName="description" cdkTextareaAutosize appTrimInput></textarea>
    
                @if(isAlternativeTranslateEnabled) {
                    <mat-icon 
                        matIconSuffix
                        #tooltip_orderName="matTooltip"
                        class="tw-cursor-pointer tw-text-gray-500"
                        [matTooltip]="'ITEMS.ALTERNATIVE_TRANSLATE' | translate"
                        matTooltipPosition="above"
                        (click)="manageAlternativeTranslate()" 
                        aria-label="'ITEMS.ALTERNATIVE_TRANSLATE' | translate">
                        language_outlined
                    </mat-icon>
                }
                
                <!-- <mat-icon 
                    matIconSuffix 
                    #tooltip_description="matTooltip"
                    class="tw-cursor-pointer tw-text-gray-500"
                    [matTooltip]="'ITEMS.DETAILS.DESCRIPTION_INFO' | translate"
                    matTooltipPosition="above"
                    (click)="tooltip_description.toggle(); $event.stopPropagation()" 
                    aria-label="Informazioni aggiuntive">
                    info_outline
                </mat-icon> -->
    
                <mat-hint [align]="'end'">{{itemDetailsSectionFormService.description?.value?.length || '0'}}
                    / {{itemDetailsSectionFormService.validators.descriptionMaxLength}}</mat-hint>
                @if(itemDetailsSectionFormService.description?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{itemDetailsSectionFormService.validators.descriptionMaxLength}})</mat-error>
                }
            </mat-form-field>
        </section>
    
        <!-- Immagini e icona -->
        <section>
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.IMAGES</mat-label>
            <section class="tw-pt-2 sm:tw-flex tw-flex-col tw-rounded-lg">
                 <div class="tw-flex tw-flex-col tw-p-3">
                    <div>
                        <input type="file" #fileInput 
                            class="hidden-file-input" accept="image/*" aria-label="image input" 
                            (change)="handleFileInput($event)"/>
                    </div>
                    <div>
                        <button mat-button color="primary" aria-label="Add" class="tw-p-0"
                            (click)="addNewImage()">
                            <div class="tw-flex tw-items-center">
                                <mat-icon>add_circle</mat-icon>
                                <span class="tw-ml-1">{{ 'ITEMS.DETAILS.ADD_IMAGE' | translate }}</span>
                            </div>
                        </button>
                    </div>
                    <mat-radio-group formControlName="thumbnail" [ngClass]="{'tw-mt-4': itemDetailsSectionFormService.images?.value.length}">
                        <div class="tw-flex tw-flex-wrap tw-gap-8">
                            @for(image of itemDetailsSectionFormService.images?.value; track image.id) {
                                <div class="image-container tw-flex tw-flex-col">
                                    <mat-icon class="remove-image mat-primary" (click)="removeImage(image)">remove_circle</mat-icon>
                                    <img [src]="image.image_url" class="img"/>
                                    <mat-radio-button color="primary" class="tw-mt-2" [value]="image.image_url"
                                        >{{ 'ITEMS.DETAILS.MAIN_IMAGE' | translate }}</mat-radio-button>
                                </div>
                            }
                        </div>
                    </mat-radio-group>
                </div>
        
                <div (click)="iconExpand = !iconExpand" class="tw-flex tw-items-center tw-p-3 tw-cursor-pointer">
                    <mat-icon class="!tw-w-8 !tw-h-8 !tw-text-[32px]">
                        {{ iconExpand ? 'arrow_drop_up' : 'arrow_drop_down' }}
                    </mat-icon>
                    <span class="tw-mr-2" translate>ITEMS.DETAILS.ICON</span>
                    <span>(&nbsp;</span>
                    @if(itemDetailsSectionFormService.icon?.value) {
                        <mat-icon class="!tw-w-6 !tw-h-6 !tw-text-[24px]" [svgIcon]="itemDetailsSectionFormService.icon?.value"></mat-icon>
                    } @else {
                        <span translate>ITEMS.DETAILS.NONE</span>
                    }
                    <span>&nbsp;)</span>
                </div>
        
                @if(iconExpand) {
                    <div class="icon-grid-container">
                    @for(icon of icons; track icon) {
                        <div class="icon-option-wrapper" 
                            [class.is-selected]="itemDetailsSectionFormService.icon?.value === icon.label"
                            (click)="selectIcon(icon.label)"
                        >
                            <mat-icon [svgIcon]="icon.label"
                                class="selection-icon"
                            ></mat-icon>
                            </div>
                        }
                    </div>
                }
            </section>
        </section>
    
        <!-- Ingredienti -->
        <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.COMPONENTS</mat-label>
        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
            <mat-form-field class="tw-col-span-12">
                <!-- Mat Chip List -->
                <mat-chip-grid #componentChipGrid class="tw-mb-2">
                    @for (component of itemDetailsSectionFormService.components?.value; track component.id) {
                        <mat-chip-row (removed)="removeComponent(component)">
                            <strong>{{ component.name }}</strong>
                            <button matChipRemove [attr.aria-label]="'remove ' + component.name">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
    
                <!-- Mat Autocomplete Input -->
                <input matInput
                    placeholder="{{ 'ITEMS.DETAILS.ENTER_AN_INGREDIENT' | translate }}"
                    #componentInput
                    [formControl]="componentCtrl"
                    [matChipInputFor]="componentChipGrid"
                    [matAutocomplete]="componentsAutocomplete"
                >
    
                <!-- Mat Autocomplete Panel -->
                <mat-autocomplete #componentsAutocomplete="matAutocomplete" (optionSelected)="onSelectComponent($event)" [displayWith]="displayComponent">
                    @for (component of filteredComponents | async; track component.id) {
                        <mat-option [value]="component">
                        <span>{{ component.name }}</span>
                        </mat-option>
                    } @empty {
                        <mat-option disabled>{{ 'ITEMS.DETAILS.NO_INGREDIENTS_FOUND' | translate }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </section>
    
        <!-- Allergeni -->
        <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.ALLERGENS</mat-label>
        <section class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4">
            @for(allergen of itemDetailsSectionFormService.allergens?.value; track allergen.id) {
                <div class="tw-flex tw-items-start">
                    <mat-checkbox [checked]="allergen.checked"
                        (change)="checkboxAllergenSelectionChange($event, allergen)">
                        <span class="tw-font-medium">{{ allergen.name }}</span>
                    </mat-checkbox>
                </div>
            }
        </section>
    
        <!-- Opzioni -->
        @if(optionNames.length) {
            <mat-label class="tw-text-xl" translate>ITEMS.DETAILS.OPTIONS</mat-label>
            <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                @for(option of optionNames; track option.index; let index = $index) {
                    <mat-form-field class="md:tw-col-span-6">
                        <!-- <mat-label translate>{{option.fieldName}}</mat-label>
                        <input matInput formControlName="{{itemDetailsSectionFormService.getOptionName(option.targetField)}}">
                        @if(index == 0 && isLeanPmsEnabled) {
                            <mat-icon class="icon-clickable"
                                (click)="selectChainProductsLeanPMS(option)">fact_check</mat-icon>
                        } -->
    
                        <mat-label translate>{{option.fieldName}}</mat-label>
                        <div class="tw-flex">
                            <input matInput [formControlName]="option.targetField" appTrimInput>
                            @if(index == 0 && isLeanPmsEnabled) {
                                <mat-icon class="icon-clickable -tw-translate-y-1.5"
                                (click)="selectChainProductsLeanPMS(option)">fact_check</mat-icon>
                            }
                        </div>
    
                        <mat-hint [align]="'end'">{{itemDetailsSectionFormService.getOptionName(option.targetField)?.value?.length || '0'}}
                            / {{itemDetailsSectionFormService.validators.optionMaxLength}}</mat-hint>
                        @if(itemDetailsSectionFormService.getOptionName(option.targetField)?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{itemDetailsSectionFormService.validators.optionMaxLength}})</mat-error>
                        }
                    </mat-form-field>
                }
            </section>
        }
    </form>
}